// extracted by mini-css-extract-plugin
export default {"parameters":"styles_parameters__fSSoe","topN":"styles_topN__L7Je8"};